import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = { url: String };

  async refresh() {
    const query = new URLSearchParams(new FormData(this.element));
    query.delete("authenticity_token");
    query.delete("_method");

    const response = await fetch(`${this.urlValue}?${query}`, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
    });
    Turbo.renderStreamMessage(await response.text());
  }
}
